import { createApp, nextTick } from 'vue'
import App from './App.vue'
import { createUnhead } from '@unhead/vue'
import { createPinia } from 'pinia'
import router from '@/router'
import PictureImage from '@/components/ui/PictureImage.vue'
import MarqueeLine from '@/components/ui/MarqueeLine.vue'
import { IMaskDirective } from 'vue-imask'
import '@/assets/scss/main.scss'

const app = createApp(App)
app.directive('imask', IMaskDirective)
app.component('PictureImage', PictureImage)
app.component('MarqueeLine', MarqueeLine)

// Подключаем плагины
app.use(router)
app.use(createUnhead())
app.use(createPinia())

app.mount('#app')
